export default "__VITE_ASSET__447c5979__"